import {Link } from 'react-router-dom'
import React, { useState, useEffect } from "react";
import mainLogo from '../../images/new_logo.png';


import { Grid, Paper, Hidden, Divider, Drawer, ListItem, List, ListItemText, IconButton } from "@material-ui/core";


function HeaderBar(props){
    const [trasparent, setTrasparent] = useState(true);
  const [numberOfItems, setNumberOfItems] = useState("")
  
  window.addEventListener("scroll", (e) => {
    setTrasparent(window.scrollY === 0);
  });

  
  
  const [openDrawer, setOpendrawer] = useState(false);


return(
    <div className="uk-container">
          
        {/** DESKTOP NAV **/}
      <div className="uk-visible@l">
             <div
      component={Grid}
      container
      className="headerBar"
      elevation={1}
      square
      style={{
        background:
          !props.fillHeader && trasparent ? "transparent" : "rgba(0,0,0,0.93)",
      }}
    >
           <div className="uk-container">
             <div className="mainNavBar">
             

             <nav class="uk-navbar-container" data-uk-navbar>

             <div class="uk-navbar-left" uk-scrollspy="cls: uk-animation-slide-left; repeat: true">
                      <Link to ="/"><img src= {mainLogo} className="logoStyle"/> </Link>
                  </div>


              
                  <div class="uk-navbar-center">
                 <nav class="stroke  "   >
                        <ul class="uk-navbar-nav ">
                            

                            <li>
                                <a href="/">Home</a>
                             
                            </li>



                            <li>
                                <a href="/about">About Us</a>
                            
                            </li>



                             <li>
                                <a href="#">Communities</a>
                                <div class="uk-navbar-dropdown">
                                    <ul class="uk-nav uk-navbar-dropdown-nav dropDown">
                                      
                                    <Link to ="/projectOne">  <li class="uk-active "><a href="#">Adelaide court</a></li> </Link>
                                      <Link to ="/projectTwo">  <li class="uk-active "><a href="#">Labella Casa</a></li> </Link>
                                      <Link to ="/vaud">  <li class="uk-active "><a href="#">Vaud Apartment</a></li> </Link>
                                  
                                    </ul>
                                </div>
                            </li>

                            <li>
                                <a href="/contact">Contact Us</a>
                            
                            </li>
                        </ul>
                        </nav>
                 </div> 


              <div class="uk-navbar-right ">
              <ul class="uk-navbar-nav"> 
                    
                </ul>
                 </div>
            </nav>






          </div>
        </div>

    </div>
    </div> {/** desktop nav ends here **/}




    
      
      {/*MOBILE NAV STARTS HERE*/}
      <div className="uk-hidden@l">
      <div
                  component={Grid}
                  container
                  className="headerBar"
                  elevation={1}
                  square
                  style={{
                    background:
                      !props.fillHeader && trasparent ? "transparent" : "rgba(0,0,0,0.93)",
                  }}
                >
                   
                        <div className="mobileNav">
                        <div className="" data-uk-grid>
                              <div className="uk-width-1-2">
                                    <div>
                                    <Link to ="/"><img src= {mainLogo} className="logoStyle"/> </Link>
                                    </div>
                              </div>

                              <div className="uk-width-1-2 ">
                                <div className="modalBtn">
                              <a class="uk-button uk-button-default  customBtn" data-uk-toggle="target: #offcanvas-flip" uk-icon="menu" uk-toggle></a>

                      <div id="offcanvas-flip" data-uk-offcanvas="flip: true; overlay: true">
                              <div class=" mobileMenuBar uk-offcanvas-bar">

                              <button class="uk-offcanvas-close" type="button" data-uk-close></button>





                               
                                     <div className="uk-margin-xlarge-top">
                                       {/***nav starts here***/}    
                                         <ul className='nav-area'>
                                         <li><Link to="/"><a href="">Home</a></Link></li>
                                         <li><Link to="/about"><a href="">About</a></Link></li>
                                             <li><Link to="/"><a href="">Communities</a></Link>
                                                 <div className='sub-nav'>
                                                  <div className='sub-menu'>
                                                    <h4>Latest Projects</h4>
                                                    <ul>
                                                    <Link to="/projectOne"> <li>Adelaide court </li></Link>
                                                    <Link to="/projectTwo"> <li> Labella Casa </li> </Link>
                                                    <Link to="/vaud"> <li> Vaud Apartment </li> </Link>
                                                      
                                                    
                                                    </ul>

                                                  </div>
                                                 </div>

                                            </li>

                                            <li><Link to="/contact"><a href="">Contact</a></Link></li>


                                           





                                         </ul>
                                     

                                      </div>

                       
                                                          










                             </div>
                       </div>
                              </div>
                              
                              
                              
                              
                              </div>
                        </div>
                        </div>
      
      
      
      
       </div>
      </div>
   














    </div>
)


}

export default HeaderBar;